'use client';

import { useTrackClickEvents } from '~/hooks/common/telemetry/useTrackClickEvents';
import useScanNewInteractiveElements from '~/hooks/dealership/useScanNewInteractiveElements';
import useTrackAdobeNavigationEvent from '~/hooks/dealership/useTrackAdobeNavigationEvent';
import useTrackAdobePageLoadEvent from '~/hooks/dealership/useTrackAdobePageLoadEvent';
import useTrackShiftDigitalClickEvent from '~/hooks/dealership/useTrackShiftDigitalClickEvent';
import useTrackShiftDigitalPageViewEvent from '~/hooks/dealership/useTrackShiftDigitalPageViewEvent';

type OwnProps = {
  trackAdobePageLoadEvent: boolean;
  trackShiftDigitalPageViewEvent: boolean;
};

export default function DealershipTracking(props: OwnProps) {
  useScanNewInteractiveElements();
  useTrackAdobeNavigationEvent();
  useTrackAdobePageLoadEvent(props.trackAdobePageLoadEvent);
  useTrackClickEvents();
  useTrackShiftDigitalClickEvent();
  useTrackShiftDigitalPageViewEvent(props.trackShiftDigitalPageViewEvent);

  return null;
}
